/* eslint-disable */

export const thingsToFix = [
  {
    index: 0,
    headline: "Search Term in Title",
    content:
      "We haven't found the search term you want to rank for in your video title. <br/> Mention <b>'search_term'</b> in your video title to rank better. <br/> Ideally right at the beginning.",
    tipHeadline: "What makes a good video title?",
    tipContent:
      "The quality of your title strongly impacts the discoverability of your video as well as the click-through rate. <br/> Mention the search term you'd like to rank for naturally in the video title. Promise value to the user with the title and sparkle interest by using words like Without, Although and To.",
  },
  {
    index: 1,
    headline: "Title Length",
    content:
      "Your title length should cannot be empty and should not 70 characters (including spaces). To ensure the entire title gets properly displayed in search results, you should stay within the 70 characters length!",
    tipHeadline: "Why is this important?",
    tipContent:
      "Though YouTube has a 100-character limit for titles, anything longer than 70 will be truncated in most search results. This might result in lower click-through rates",
  },
  {
    index: 2,
    headline: "Search Term in Description",
    content:
      "The first paragraph of your description does not contain your search term. <br/>Mention <b>'search_term'</b> in exactly this wording in one of the first three sentences.",
    tipHeadline: "What to consider when including keywords?",
    tipContent:
      "Write for readers first – then focus on keyword use. <br/> Use synonyms, variations, or contextually related words of your main search term. <br/> Don't use keywords too often since it's against Google's quality guidelines.",
  },
  {
    index: 3,
    headline: "Video Chapters",
    content:
      "We couldn't detect any chapters for your video. <br/> To create chapters add a list of timestamps to your description in the following format:",
    tipHeadline: "What are YouTube Chapters?",
    tipContent:
      "Chapters break up your YouTube video into sections. Video Chapters are automatically generated based on timestamps you enter in the video description and will show in the video progress bar (aka the 'video scrubber bar') below your video.",
  },
  {
    index: 4,
    headline: "Outbound Links",
    content:
      "We couldn't detect any external links in the video's description. <br/> Add links to websites that help your audience after watching the video in the format:",
    tipHeadline: "How to track link clicks?",
    tipContent:
      "You can track which links in your descriptions get clicked by adding UTM parameters to the end of a URL. <br/> Use URL Shorteners to make links more appealing.",
  },
  {
    index: 5,
    headline: "Hashtags",
    content:
      "We couldn't detect any hashtags in the video description.<br/>Add hashtags that are associated with a trend or your brand (max. 15 hashtags).",
    tipHeadline: "Why are hashtags important?",
    tipContent:
      "You can use hashtags (#) in video descriptions to help viewers find your video when they search for a specific hashtag. <br/> Ensure that you only use hashtags related to your video. Hashtags are most helpful with trending content, such as upcoming events or people in the news.",
  },
  {
    index: 6,
    headline: "Description Length",
    content:
      "The length of your video description is shorter than the length of the top 3 ranking videos (). Change the length so that it is at least the recommended characters.",
    tipHeadline: "How is the recommended description length calculated?",
    tipContent:
      "The recommended character length is an average of the top 3 YouTube videos that rank for your topic.",
  },
  {
    index: 7,
    headline: "Tags Set",
    content:
      "Your video metadata doesn’t feature any tags.<br/>Try to add tags that <b>mirror the content of your video.</b>",
    tipHeadline: "Which tags to enter?",
    tipContent:
      "Tags are designed so that YouTube understands your video immediately after uploading and can recommend it to users.<br/> Enter 5-8 tags that accurately describe the topic of your video. Use tags with a length of 2-3 words.",
  },
  {
    index: 8,
    headline: "Tag Quality",
    content:
      "You haven´t added enough tags to give YouTube a good overview of your video´s content.<br/>Add at least 5 Recommended Tags that mirror the content of your video.<br/>You can see the recommended tags below your tag box.",
    tipHeadline: "Which tags to enter?",
    tipContent:
      "Tags are designed so that YouTube understands your video immediately after uploading and can recommend it to users. Enter 5-8 tags that accurately describe the topic of your video. Use tags with a length of 2-3 words.",
  },
  {
    index: 9,
    headline: "Search Term in Tags",
    content:
      "We haven’t found your search term <b>'search_term'</b> in your tags.<b/>Make sure that your first tag is the exact, word-for-word topic that you want to rank for.",
    tipHeadline: "Learn Why",
    tipContent:
      "When it comes to video SEO, YouTube pays special close attention to your first few tags. There's a small but significant relationship between YouTube tags and ranking in YouTube.",
  },
  {
    index: 10,
    headline: "Explicit Content",
    content:
      "Google's SafeSearch algorithm found critical elements in your thumbnail.",
    tipHeadline: "How is Google's SafeSearch algorithm working?",
    tipContent:
      "Google's SafeSearch algorithm scans each video to see if it could contain explicit content. The algorithm will prevent any video from showing in search results on the slightest suspicion it may contain explicit content.",
  },
];

export const itemsFixed = [
  {
    index: 0,
    headline: "Search Term in Title",
    content:
      "Well done! We found the search term you want to rank for in your video title.",
    tipHeadline: "What makes a good video title?",
    tipContent:
      "The quality of your title strongly impacts the discoverability of your video as well as the click-through rate. <br/> Mention the search term you'd like to rank for naturally in the video title. Promise value to the user with the title and sparkle interest by using words like Without, Although and To.",
  },
  {
    index: 1,
    headline: "Title Length",
    content:
      "Good job! The length of your video title gets displayed well in search results.",
    tipHeadline: "Why is this important?",
    tipContent:
      "Though YouTube has a 100-character limit for titles, anything longer than 70 will be truncated in most search results. This might result in lower click-through rates",
  },
  {
    index: 2,
    headline: "Search Term in Description",
    content:
      "Great!! Your description contains the search term <b>'search_term'</b> you chose to rank for.",
    tipHeadline: "What to consider when including keywords?",
    tipContent:
      "Write for readers first – then focus on keyword use. <br/> Use synonyms, variations, or contextually related words of your main search term. <br/> Don't use keywords too often since it's against Google's quality guidelines.",
  },
  {
    index: 3,
    headline: "Video Chapters",
    content: "Good Work. We found chapters in your video description.",
    tipHeadline: "What are YouTube Chapters?",
    tipContent:
      "Chapters break up your YouTube video into sections. Video Chapters are automatically generated based on timestamps you enter in the video description and will show in the video progress bar (aka the 'video scrubber bar') below your video.",
  },
  {
    index: 4,
    headline: "Outbound Links",
    content:
      "Nicely Done! We detected external links in the video's description. <br/> Adding links to websites will help your audience after watching the video",
    tipHeadline: "How to track link clicks?",
    tipContent:
      "You can track which links in your descriptions get clicked by adding UTM parameters to the end of a URL. <br/> Use URL Shorteners to make links more appealing.",
  },
  {
    index: 5,
    headline: "Hashtags",
    content:
      "Bravo! hashtags are in the video description.<br/>Remember hashtags should be associated with a trend or your brand (max. 15 hashtags).",
    tipHeadline: "Why are hashtags important?",
    tipContent:
      "You can use hashtags (#) in video descriptions to help viewers find your video when they search for a specific hashtag. <br/> Ensure that you only use hashtags related to your video. Hashtags are most helpful with trending content, such as upcoming events or people in the news.",
  },
  {
    index: 6,
    headline: "Description Length",
    content:
      "The length of your video description is shorter than the length of the top 3 ranking videos (). Change the length so that it is at least the recommended characters.",
    tipHeadline: "How is the recommended description length calculated?",
    tipContent:
      "The recommended character length is an average of the top 3 YouTube videos that rank for your topic.",
  },
  {
    index: 7,
    headline: "Tags Set",
    content:
      "Nice! Great work. Your video metadata contain tags.<br/>Ensure to add tags that <b>mirror the content of your video.</b>",
    tipHeadline: "Which tags to enter?",
    tipContent:
      "Tags are designed so that YouTube understands your video immediately after uploading and can recommend it to users.<br/> Enter 5-8 tags that accurately describe the topic of your video. Use tags with a length of 2-3 words.",
  },
  {
    index: 8,
    headline: "Tag Quality",
    content: "You have set proper tags for your video. Good!",
    tipHeadline: "Which tags to enter?",
    tipContent:
      "Tags are designed so that YouTube understands your video immediately after uploading and can recommend it to users. Enter 5-8 tags that accurately describe the topic of your video. Use tags with a length of 2-3 words.",
  },
  {
    index: 9,
    headline: "Search Term in Tags",
    content:
      "Good! We found your search term <b>'search_term'</b> in your tags.<b/>Make sure that your first tag is the exact, word-for-word topic that you want to rank for.",
    tipHeadline: "Learn Why",
    tipContent:
      "When it comes to video SEO, YouTube pays special close attention to your first few tags. There's a small but significant relationship between YouTube tags and ranking in YouTube.",
  },
  {
    index: 10,
    headline: "Explicit Content",
    content:
      "Google's SafeSearch algorithm hasn't found any critical elements in your thumbnail.",
    tipHeadline: "How is Google's SafeSearch algorithm working?",
    tipContent:
      "Google's SafeSearch algorithm scans each video to see if it could contain explicit content. The algorithm will prevent any video from showing in search results on the slightest suspicion it may contain explicit content.",
  },
];

// export const itemsFixed = [
//   {
//     headline: "Explicit Content",
//     content:
//       "Google's SafeSearch algorithm hasn't found any critical elements in your thumbnail.",
//     tipHeadline: "How is Google's SafeSearch algorithm working?",
//     tipContent:
//       "Google's SafeSearch algorithm scans each video to see if it could contain explicit content. The algorithm will prevent any video from showing in search results on the slightest suspicion it may contain explicit content.",
//   },
// ];
